var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-list"},_vm._l((_vm.list),function(item){return _c('ul',{key:item.id,staticClass:"brand-item"},[_c('li',{staticClass:"icon"},[_c('img',{attrs:{"src":item.img,"alt":item.slug}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }